export const FEATURE_FLAGS = [
  {
    key: 'PUBLIC_PRIVATE_OVERRIDE' as const,
    desc: 'Show control to override public/private on incident locations'
  },
  {
    key: 'ENABLE_ADS' as const,
    desc: 'Shows Google Ads in various places'
  },
]satisfies readonly { key: string, desc: string }[]
